export const colors = {
  darkBlue: '#1473dd',
  blue: '#136dd1',
  lightBlue: '#3799ff',
  grey: '#eef1f5',
  darkGrey: '#acaeb0',
}
